module.exports = __webpack_public_path__ + "img/f-thermometer-img8-2.d5dac4b2.png";